module.exports = __webpack_public_path__ + "img/Kürbisser Franz.jpg";